import { writable } from 'svelte/store';
const userInfoObj = {};
const snackbarConfig = {
    message: undefined,
    color: 'success',
    show: false
};
const confirmDialogConfig = {
    title: undefined,
    message: undefined,
    show: false
};
function createSnackbar() {
    const { subscribe, set, update } = writable(snackbarConfig);
    return {
        subscribe,
        show: (message, color = 'success') => {
            set({
                message,
                color,
                show: true
            });
        }
    };
}
function createConfirmDialog() {
    const { subscribe, set, update } = writable(confirmDialogConfig);
    return {
        subscribe,
        show: (title, message, confirmAction, declineAction) => {
            set({
                title,
                message,
                show: true,
                confirmAction,
                declineAction
            });
        },
        hide: () => {
            set({
                title: undefined,
                message: undefined,
                show: false
            });
        }
    };
}
export const userInfo = writable(userInfoObj);
export const snackbar = createSnackbar();
export const confirmDialog = createConfirmDialog();
